//https://gist.github.com/smeijer/6580740a0ff468960a5257108af1384e

const ParseEsTemplate = {
  install: Vue => {
    Vue.prototype.$parseEsTemplate = {
      parse(template, map, fallback) {
        return template.replace(/\${([^{]+)}/g, match => {
          const path = match.substr(2, match.length - 3).trim();
          return this.get(path, map, fallback);
        });
      },
      get(path, obj, fb = "" /*`$\{${path}}`*/) {
        return path
          .split(".")
          .reduce((res, key) => eval(`res.${key}`) || fb, obj);
      }
    };
  }
};

export default ParseEsTemplate;



//////////////////
// WEBPACK FOOTER
// ./Helpers/Plugins/parseEsTemplate.js
// module id = TAan
// module chunks = 18